import {InjectionToken} from "@angular/core";
import {ILanguageResolverService} from "./iLanguageResolverService";

export const languageResolverServiceInjectionToken: InjectionToken<ILanguageResolverService> = new InjectionToken<ILanguageResolverService>("dashboard-web.LanguageResolverService");
